angular.module("survey").directive("surveyVideo", [surveyVideo])
function surveyVideo() {
  return {
    restrict: "A",
    link: function($scope, elem, attrs) {
      $scope.$on("pageChange", function() {
        // stop video playing when page changes
        elem[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
      })
    }
  }
}

angular.module("survey").filter("youtubeEmbed", ["$sce", youtubeEmbed])
function youtubeEmbed($sce) {
  return function(video) {
    return $sce.trustAsResourceUrl("http://www.youtube.com/embed/" + video + "?enablejsapi=1")
  }
}